import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const MessageBoxStyled = styled(FlexContainer)`
  width: 100%;
  max-width: 800px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
  left: 0;
  padding: 2px;
  border: ${({ theme }) => theme.borders.md};
  border-radius: ${({ theme }) => theme.radius.lg};
  color: ${({ theme }) => theme.colors.highlight.variant2};
  ${({ theme }) => `
    ${theme.devices.tablet} {
      width: 90%;
    }
  `}
`;

export const MessageBoxContentStyled = styled.div`
  width: 100%;
  height: 100%;
  max-height: 70px;
  padding: 4px;
  overflow-y: auto;
`;
